import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import { createAuth } from './auth'
import axios from 'axios'

import "@/assets/scss/main.scss"
import { useMainStore } from './store'

const auth = createAuth(`${process.env.VUE_APP_API_URL}/admin`, '/login', '/invite', '/logout', '/me')

const app = createApp(App).use(createPinia()).use(router)

let initialized = false

auth.on('ready', async ()=>{
    axios.get(`${process.env.VUE_APP_API_URL.replace('/v2', '')}/sanctum/csrf-cookie`).then(async () => {
        if( !initialized ){
            const user = await auth.user() 
            if(user){
                useMainStore().login( user )
            }
            app.mount('#app')
            initialized = true
        }
    });
})